module.exports = __webpack_public_path__ + "static/media/rightArrowLight.218044e4.svg";